<template>
	<div id="role-list">
		<v-subheader class="v-subheader">
			<v-layout>
				<v-icon class="text--secondary ma-1">device_hub</v-icon>
				<h1 class="text--secondary text-uppercase">{{ $t('roles.title') }}</h1>
			</v-layout>
		</v-subheader>
		<v-layout class="ma-5 align-center column justify-center">
			<div class="ma-5 align-center justify-center table-wrap">
				<roles-table :roles="roles">
				</roles-table>
			</div>
		</v-layout>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import RolesTable from './roles-table';

	export default {
		name: 'RolesList',
		components: { RolesTable },
		computed: {
			...mapState({
				roles: state => state.role.roles,
			})
		},
		mounted() {
			this.getAllRoles();
		},
		methods: {
			...mapActions({
				getAllRoles: 'role/getAllRoles',
			}),
		},
	};
</script>

<style lang="scss" scoped>
	@import "@/styles/colors";

	.v-subheader {
		min-height: 100px;
		padding: 20px;
		background-color: $light-grey;
	}

	.table-wrap {
		width: 80%;
	}
</style>
